import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfNegocio } from 'src/database/index';

import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

interface NegocioCpfProps {
  NOME: string;
  DATANASCIMENTO: string;
}

export const useFormCreateNegocio = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState(false);
  const [NegocioCpf, setNegocioCpf] = useState<NegocioCpfProps[]>([{ NOME: '', DATANASCIMENTO: '' }]);
  const [negocioResponse, setNegocioResponse] = useState<AxiosResponse | null>(null);
  const [negocioEditedResponse, setNegocioEditedResponse] = useState<AxiosResponse | null>(null);

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    ORGAO: Yup.string(),
    CNPJ: Yup.string().required('* Campo obrigatório'),
    RAZAOSOCIAL: Yup.string().required('* Campo obrigatório'),
    ENDERECO: Yup.string(),
    CEP: Yup.string(),
    BAIRRO: Yup.string(),
    MUNICIPIO: Yup.string(),
    EMAIL: Yup.string(),
  });

  const saveNegocio = (Negocio: ModelOfNegocio) => {
    setLoading(true);

    const newNegocio: ModelOfNegocio = {
      ...Negocio,
      ORGAO: userAgencyId,
    };
    console.log("newNegocio", newNegocio)
    if (!!negocioResponse) {
      api.put(`negocios/${negocioResponse.data.ID}`, newNegocio)
        .then((response) => {
          formik.resetForm();
          setNegocioEditedResponse(response);
          setNegocioResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'O credor foi editado com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      console.log("newNegocio:", newNegocio)
      api.post('/negocios', newNegocio)
        .then((response) => {
          setNegocioResponse(response);
          setNegocioEditedResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  };

  const formik = useFormik<ModelOfNegocio>({
    initialValues: {
      ORGAO: '',
      CNPJ: '',
      RAZAOSOCIAL: '',
      ENDERECO: '',
      CEP: '',
      BAIRRO: '',
      MUNICIPIO: '',
      EMAIL: '',
    },
    onSubmit: async values => await saveNegocio(values),
    validationSchema
  });

 
  

  return {
    getNegocioFormController: {
      formik,
      loading,
      NegocioCpf,
      toast,
      negocioResponse,
      negocioEditedResponse
    },
    handleNegocioFormController: {
      setNegocioResponse,
      setNegocioEditedResponse
    }
  };
};